export default {
  primaryFontStack: '',
};
